import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { IconButton, Typography } from '@mui/material';

import { Tag } from '../../../../components/common';
import { StyledFileItem, StyledVerticalContent } from './FileUploader.styled';
import DeleteIcon from '../../../../icons/DeleteIcon';

function FileList(props) {
  const { files, onRemove } = props;

  const validFiles = files?.filter((file) => file?.valid) || [];
  const invalidFiles = files?.filter((file) => !file?.valid) || [];

  return (
    <>
      {validFiles.map((file) => (
        <FileItem
          key={file?.fileId}
          fileId={file?.fileId}
          file={file?.file}
          isValidFile={file?.valid}
          error={file?.error}
          onRemove={onRemove}
        />
      ))}

      {invalidFiles.map((file) => (
        <FileItem
          key={file?.fileId}
          fileId={file?.fileId}
          file={file?.file}
          isValidFile={file?.valid}
          error={file?.error}
          onRemove={onRemove}
        />
      ))}
    </>
  );
}

export default FileList;

FileList.propTypes = {
  onRemove: PropTypes.func,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      fileId: PropTypes.string,
      file: PropTypes.shape({}),
      valid: PropTypes.bool,
      error: PropTypes.string,
    })
  ),
};

function FileItem(props) {
  const { fileId, file, isValidFile, error, onRemove } = props;

  const fileNameText = file?.name || file?.path || fileId;

  return (
    <StyledFileItem>
      <StyledVerticalContent>
        <Typography variant="h3" color={isValidFile ? 'professional_blue' : 'product_blue'}>
          {fileNameText}
        </Typography>

        {isValidFile && (
          <Tag variant="success" data-testid="valid_file_tag">
            <Typography variant="p">
              <FormattedMessage id="new_claim.file.ready.to.upload" />
            </Typography>
          </Tag>
        )}

        {!isValidFile && error && (
          <Tag variant="error" data-testid="invalid_file_tag">
            <Typography variant="p">{error}</Typography>
          </Tag>
        )}
      </StyledVerticalContent>

      {!!onRemove && (
        <IconButton variant="round" onClick={(ev) => onRemove(ev, fileId)} aria-label="delete file">
          <DeleteIcon />
        </IconButton>
      )}
    </StyledFileItem>
  );
}

FileItem.propTypes = {
  fileId: PropTypes.string.isRequired,
  isValidFile: PropTypes.bool.isRequired,
  error: PropTypes.string,
  onRemove: PropTypes.func,
  file: PropTypes.shape({
    name: PropTypes.string,
    path: PropTypes.string,
  }).isRequired,
};
